import { toastr } from 'react-redux-toastr';
import { AxiosResponse } from 'axios';
import { getCustomerOrderSalesReport } from '../../api/Reports/ReportsApi';
import { ICustomerOrderSalesReportParams } from '../../api/Reports/CustomerSales/ICustomerOrderSalesParams';
import { ICustomerOrderSalesReportResponse } from '../../api/Reports/CustomerSales/ICustomerOrderSalesReportResponse';

export const GET_CUSTOMER_ORDER_SALES_REPORT_REQUEST = 'GET_CUSTOMER_ORDER_SALES_REPORT_REQUEST';
export const GET_CUSTOMER_ORDER_SALES_REPORT_RESPONSE = 'GET_CUSTOMER_ORDER_SALES_REPORT_RESPONSE';
export const GET_CUSTOMER_ORDER_SALES_REPORT_ERROR = 'GET_CUSTOMER_ORDER_SALES_REPORT_ERROR';

export const getCustomerOrderSalesReportRequest = (
  parameters: ICustomerOrderSalesReportParams,
  onSuccess: (data: any) => void,
): any => {
  return (dispatch: any) => {
    dispatch({
      type: GET_CUSTOMER_ORDER_SALES_REPORT_REQUEST,
    });
    return getCustomerOrderSalesReport(parameters)
      .then((response: AxiosResponse<ICustomerOrderSalesReportResponse>) => {
        if (response.status === 200) {
          dispatch({
            type: GET_CUSTOMER_ORDER_SALES_REPORT_RESPONSE,
          });
          toastr.success('Report Generated', 'The customer sales report has been exported successfully.');
          onSuccess(response.data);
        } else {
          onError(dispatch);
        }
      })
      .catch((err: any) => {
        console.log(err);
        onError(dispatch);
      });
  };
};

const onError = (dispatch: any) => {
  dispatch({
    type: GET_CUSTOMER_ORDER_SALES_REPORT_ERROR,
  });
  toastr.error('Error', 'An error has occurred whilst exporting the customer sales report. Please try again.');
};
